import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ListingTable from "./OutletsAndRegistersListing";
import AddReceiptTemplate from "./AddReceiptTemplate";
import EditOutlet from "./EditOutlet";
import AddEditRegister from "./AddEditRegister";
import MainRegister from "./MainRegister";

const OutletsAndRegisters = ({ match }) => (
    <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/listing`} />
        <Route path={`${match.url}/listing`} component={ListingTable} />
        <Route path={`${match.url}/addtemplate`} component={AddReceiptTemplate} />
        <Route path={`${match.url}/edittemplate/:id`} component={AddReceiptTemplate} />
        <Route path={`${match.url}/editoutlet/:id/:showDel`} component={EditOutlet} />
        <Route path={`${match.url}/editregister/:id/:isDelOutlet`} component={AddEditRegister} />
        <Route path={`${match.url}/addregister/:id`} component={AddEditRegister} />
        {/* <Route path={`${match.url}/mainregister`} component={MainRegister} /> */}
    </Switch>
);

export default OutletsAndRegisters;